import { MinimalButton } from '@calendly/ui/components/minimal-button'

import { useI18n } from 'locales'

import { Centered } from './styles'

export default ({ onClick }) => {
  const { i18n } = useI18n()
  return (
    <Centered>
      <MinimalButton fontSize="medium" onClick={onClick}>
        {i18n.t('booking.mutual_availability.login.this_is_not_me')}
      </MinimalButton>
    </Centered>
  )
}
